
import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import present from "../assets/StatusIcons/present.svg";
import absent from "../assets/StatusIcons/absent.svg";
import earlyout from "../assets/StatusIcons/earlyout.svg";
import leave from "../assets/StatusIcons/leave.svg";
import late from "../assets/StatusIcons/late.svg";
import halfleave from "../assets/StatusIcons/halfleave.svg";
import task from "../assets/StatusIcons/task.svg";
import active from '../assets/Dashboard/active.svg';
import inactive from '../assets/Dashboard/inactive.svg';
import trial from '../assets/Dashboard/trial.svg';
import invited from '../assets/Dashboard/invited.svg';
import request from '../assets/Dashboard/request.svg';
import process from "../assets/Dashboard/process.svg";
import overdue from "../assets/Dashboard/overdue.svg";
import received from "../assets/Wallet/received.svg";
import pending from "../assets/Wallet/pending.svg";
import { useTranslation } from 'react-i18next';
import valid from "../assets/Attendance/valid.svg"
import i18n from 'i18next';
import cancel from "../assets/StatusIcons/cancel.svg";
import expire from "../assets/StatusIcons/expire.svg";
import tobepaid from "../assets/StatusIcons/tobepaid.svg";
import { statusStyles as centralStatusStyles } from "../constants/statusPalette";

const WorkerStatusDropdown = ({ currentStatus, onChange,statusOptions = [] ,  showArrow = true // 👈 NEW PROP with default true
 }) => {
  const { t } = useTranslation();

//   console.log('🌐 Language:', i18n.language);
// console.log('🔑 Translated status:', t(`status.${currentStatus}`));
const statusIcons = {
  Present: present,
  CLOCK_IN:present,
   PRESENT: present,
cancelled: cancel,
CANCELLED: cancel,
cancel:cancel,
complete:present,
expired: expire,
   Validated: present,
  Paid:present,
    paid:present,

  completed: present,
 Verified: present,
  verified: present,
    Approved: present,
        approved: present,
                APPROVED: present,


  Absent: absent,
  Invalid:absent,
 Error: absent,
  Delayed: absent,
   Rejected: absent,
      REJECTED: absent,

      rejected: absent,

  Leave: leave,
  assigned: leave,
  Pending:halfleave,
    email_pending:leave,

    pending:halfleave,
    PENDING:halfleave,

    valid:valid,
  'Early Out': earlyout,  
    Ongoing: earlyout,      // ✅ Use quotes because of the space
  'Late Arrival': late,
  'ON_BREAK':late,
   'in_progress': halfleave,
  'Half Leave': halfleave,
   Paused: halfleave,
    'Requested': halfleave,
        'Request': halfleave,
        toBePaid: tobepaid,
    Active: present,
      active: present,
          approve: active,

  Invited: invited,
    invited: invited,
    Requested: request,
     Inactive: inactive,
          inactive: inactive,

     high:task,
     medium:task,
     urgent:task,
     low:task,
     CHECKED_OUT:absent,
     CLOCK_OUT:absent,
     ABSENT:absent,
     not_done:absent,
     BACK_FROM_BREAK:halfleave

};
const statusStyles = {
  CLOCK_IN:{ backgroundColor: '#4BCE97', color: '#164B35' },
  Present: { backgroundColor: '#4BCE97', color: '#164B35' },
   PRESENT: { backgroundColor: '#4BCE97', color: '#164B35' },
  Validated: { backgroundColor: '#4BCE97', color: '#164B35' },
    Paid: { backgroundColor: '#4BCE97', color: '#164B35' },
        paid: { backgroundColor: '#4BCE97', color: '#164B35' },

  completed: centralStatusStyles.completed,
    complete: centralStatusStyles.completed,

 Verified: { backgroundColor: '#4BCE97', color: '#164B35' },
  verified: { backgroundColor: '#4BCE97', color: '#164B35' },
  Approved: { backgroundColor: '#4BCE97', color: '#164B35' },
    APPROVED: { backgroundColor: '#4BCE97', color: '#164B35' },

    approved: { backgroundColor: '#4BCE97', color: '#164B35' },
        approve: { backgroundColor: '#4BCE97', color: '#164B35' },


  cancelled:{ backgroundColor: '#FEA362', color: '#702E00' },
    cancel:{ backgroundColor: '#FEA362', color: '#702E00' },

    CANCELLED:{ backgroundColor: '#FEA362', color: '#702E00' },

    expired:{ backgroundColor: '#091E4224', color: '#44546F' },
  Absent: { backgroundColor: '#F87168', color: '#5D1F1A' },
    not_done: { backgroundColor: '#F87168', color: '#5D1F1A' },
 CHECKED_OUT: { backgroundColor: '#F87168', color: '#5D1F1A' },
  CLOCK_OUT: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Invalid: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Error: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Delayed: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
    REJECTED: { backgroundColor: '#F87168', color: '#5D1F1A' },

    rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },

  ABSENT: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Leave: { backgroundColor: '#579DFF', color: '#09326C' },
  assigned: centralStatusStyles.assigned,
Pending: { backgroundColor: ' #F5CD47', color: '#533F04' },
pending: {backgroundColor: '#F5CD47', color: '#533F04' },
email_pending: { backgroundColor: '#579DFF', color: '#09326C' },
PENDING: { backgroundColor: '#F5CD47', color: '#533F04' },

  'Early Out': { backgroundColor: '#9F8FEF', color: '#352C63' }, // ✅ Fix here
   Ongoing: { backgroundColor: '#9F8FEF', color: '#352C63' },
  'Late Arrival': { backgroundColor: '#FEA362', color: '#702E00' },
    'ON_BREAK': { backgroundColor: '#FEA362', color: '#702E00' },

   'in_progress': centralStatusStyles.in_progress,
  'Half Leave': { backgroundColor: '#F5CD47', color: '#533F04' },
   Paused: { backgroundColor: '#F5CD47', color: '#533F04' },
      BACK_FROM_BREAK: { backgroundColor: '#F5CD47', color: '#533F04' },

   'Requested': { backgroundColor: '#F5CD47', color: '#533F04' },
   'Request': { backgroundColor: '#F5CD47', color: '#533F04' },
     Active: { backgroundColor: '#4BCE97', color: '#164B35' },
          active: { backgroundColor: '#4BCE97', color: '#164B35' },
        Invited: { backgroundColor: '#579DFF', color: '#09326C' },
         invited: { backgroundColor: '#579DFF', color: '#09326C' },
         toBePaid: { backgroundColor: '#579DFF', color: '#09326C' },
         Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
          Inactive: centralStatusStyles.Inactive,
                    inactive: centralStatusStyles.inactive,

        low: { backgroundColor: '#BCBFC2', color: '#44546F' },
        medium: { backgroundColor: '#579DFF', color: '#09326C' },
       high: { backgroundColor: '#FEA362', color: '#702E00' },
     urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
     valid: { backgroundColor: '#579DFF', color: '#ffffff' },
};
const canOpenDropdown = Object.keys(statusStyles).filter(
  status => status !== '' && status !== 'Received'
);
const showDropdownIcon = ['', '', '', '','',''];
const allStatuses = Object.keys(statusStyles);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (canOpenDropdown.includes(currentStatus)) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = (status) => {
    if (status) onChange(status);
    setAnchorEl(null);
  };
  const displayStatusLabels = {
  initiated: 'Processing',
  success: 'Paid',
  failed: 'Failed',
  // Add other overrides if needed
};
  return (
    <>
      <Box
  onClick={handleClick}
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // ✅ centers text + icon
    gap: 0.5,
    px: 0.4,
    py: 0.4,
    borderRadius: '4px',
    fontWeight: 400,
    fontFamily: 'Poppins, sans-serif',
    fontSize: '13px',
    cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
    width: 120,              // ✅ fixed equal width for all
    minWidth: 120,           // ✅ ensure consistency
    maxWidth: 120,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    ...statusStyles[currentStatus]
  }}
>
        <img src={statusIcons[currentStatus]} alt={currentStatus} style={{ width: 20, height: 20 }} />
      
        <Typography sx={{ fontSize: '13px',  fontFamily: 'Poppins, sans-serif', color: (statusStyles[currentStatus]?.color || '#333333') }}>
  {/* {displayStatusLabels[currentStatus] || currentStatus} */}
    {t(`statuses.${displayStatusLabels[currentStatus] || currentStatus}`)}

 

</Typography>
      
{showArrow && (
  <ArrowDropDownIcon
    sx={{ fontSize: 18, color: statusStyles[currentStatus]?.color }}
  />
)}      
      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
       
        {statusOptions.map((status) => (
  <MenuItem key={status} onClick={() => handleClose(status)}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <img src={statusIcons[status]} alt={status} style={{ width: 16, height: 16 }} />
      <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}>
        {/* {status} */}
          {t(`statuses.${status}`)}
        </Typography>
    </Box>
  </MenuItem>
))}
      </Menu>
    </>
  );
};

export default WorkerStatusDropdown;